var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticket-evaluation"},[_c('evaluation',{attrs:{"greetings":"请对本次服务评价，我们将持续优化","scores":_vm.scores,"onSubmit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }